module.exports = __webpack_public_path__ + "static/media/logo_Baumax.ada7a2ab.jpg";